import axios from "axios";
import { DateTime } from "luxon";
import jwtDecode from "jwt-decode";

import authService from "@/services/authService";

const state = () => ({
  access_token: localStorage.getItem("access_token") || "",
  user: localStorage.getItem("access_token")
    ? jwtDecode(localStorage.getItem("access_token"))
    : null
});

const actions = {
  async register({ dispatch }, { email, password, username, firstName, lastName }) {
    try {
      await authService.register({
        email,
        password,
        firstName,
        lastName,
        username
      });
      return Promise.resolve();
    } catch (error) {
      dispatch(
        "common/showError",
        "Benutzer konnte nicht registriert werden. Eventuell ist die E-Mail bereits vergeben.",
        { root: true }
      );
      return Promise.reject();
    }
  },
  async login({ commit, dispatch }, { username, password }) {
    try {
      const res = await authService.login({ username, password });
      commit("loginSuccess", res.data.access_token);
      return Promise.resolve();
    } catch (error) {
      dispatch("common/showError", "Benutzername oder Passwort ist falsch.", {
        root: true
      });
      return Promise.reject();
    }
  },
  logout({ commit }, router) {
    commit("logout");
    router.push({ name: "Login" });
  }
};

const getters = {
  isLoggedIn: state => {
    if (!state.access_token) {
      return false;
    }

    let decoded = null;
    try {
      decoded = jwtDecode(state.access_token);
    } catch (e) {
      return false;
    }

    if (
      decoded.exp &&
      DateTime.local() < DateTime.fromMillis(decoded.exp * 1000)
    ) {
      axios.defaults.headers.common = {
        Authorization: `bearer ${state.access_token}`
      };
      return true;
    }

    return false;
  }
};

const mutations = {
  loginSuccess(state, access_token) {
    state.access_token = access_token;
    state.user = jwtDecode(access_token);
    localStorage.setItem("access_token", access_token);
    axios.defaults.headers.common.Authorization = access_token;
  },
  logout(state) {
    state.access_token = null;
    state.user = null;
    localStorage.removeItem("access_token");
    axios.defaults.headers.common.Authorization = null;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
